<script setup>
import ChipStatus from '@/components/shared/ChipStatus.vue'
import { DxTagBox } from 'devextreme-vue/tag-box'

const props = defineProps({
  tags: {
    type: Array,
    default: () => [],
  },
  value: {
    type: Array,
    default: () => [],
  },
  disabled: {
    type: Boolean,
    default: false,
  },
})

</script>

<template>
  <dx-tag-box
    :items="props.tags"
    :value="props.value"
    apply-value-mode="useButtons"
    multiline
    value-expr="id"
    display-expr="name"
    :disabled="props.disabled"
  >
    <template #tagTemplate="{ data }">
      <chip-status :data="props.tags.find(x => x.id === data?.id)" />
    </template>
  </dx-tag-box>
</template>
